import { render, staticRenderFns } from "./serve_s.vue?vue&type=template&id=4b01706e&scoped=true&"
import script from "./serve_s.vue?vue&type=script&lang=js&"
export * from "./serve_s.vue?vue&type=script&lang=js&"
import style0 from "./serve_s.vue?vue&type=style&index=0&id=4b01706e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b01706e",
  null
  
)

export default component.exports